(function () {
  'use strict';

  const SELECTORS = {
    grid: '.collections-grid',
    card: '.collection-card-redesign',
    filterCheckbox: '.collections-filter-option input[type="checkbox"]',
    priceMin: '#collections-price-min',
    priceMax: '#collections-price-max',
    priceMinLabel: '#collections-price-min-label',
    priceMaxLabel: '#collections-price-max-label',
    sortSelect: '.collections-sort__select',
    filterDrawer: '.collections-filter-drawer',
    filterDrawerOpen: '.collections-mobile-filter-btn',
    filterDrawerClose: '.collections-filter-drawer__close',
    filterDrawerOverlay: '.collections-filter-drawer__overlay',
    filterDrawerApply: '.collections-filter-drawer__apply',
    sortDrawer: '.collections-sort-drawer',
    sortDrawerOpen: '.collections-mobile-sort-btn',
    sortDrawerClose: '.collections-sort-drawer__close',
    sortDrawerOverlay: '.collections-sort-drawer__overlay',
    sortRadio: '.collections-sort-drawer__option input[type="radio"]',
    filterDrawerClear: '.collections-filter-drawer__clear',
    filterGroup: '.collections-filter-group__header',
    noResults: '.collections-no-results',
    showMore: '.collections-show-more',
  };

  const MOBILE_CARD_LIMIT = 6;
  const DESKTOP_CARD_LIMIT = 12;
  const MOBILE_BREAKPOINT = 749;

  let isHydrating = false;
  let writeStateTimer = null;

  /* ── URL state ── */

  function readState() {
    const params = new URLSearchParams(location.search);
    const etRaw = params.get('event_type') || '';
    const rgRaw = params.get('region') || '';
    const minRaw = params.get('min_price');
    const maxRaw = params.get('max_price');
    return {
      eventType: etRaw ? etRaw.split(',').filter(Boolean) : [],
      region: rgRaw ? rgRaw.split(',').filter(Boolean) : [],
      minPrice: minRaw !== null ? parseInt(minRaw, 10) : null,
      maxPrice: maxRaw !== null ? parseInt(maxRaw, 10) : null,
      sort: params.get('sort') || null,
    };
  }

  function writeState(state) {
    const params = new URLSearchParams();
    const pMin = document.querySelector(SELECTORS.priceMin);
    const pMax = document.querySelector(SELECTORS.priceMax);
    const absMin = pMin ? parseInt(pMin.min, 10) : 0;
    const absMax = pMax ? parseInt(pMax.max, 10) : 0;

    if (state.eventType && state.eventType.length) params.set('event_type', state.eventType.join(','));
    if (state.region && state.region.length) params.set('region', state.region.join(','));
    if (state.minPrice != null && state.minPrice !== absMin) params.set('min_price', String(state.minPrice));
    if (state.maxPrice != null && state.maxPrice !== absMax) params.set('max_price', String(state.maxPrice));
    if (state.sort && state.sort !== 'relevance') params.set('sort', state.sort);

    const qs = params.toString();
    history.replaceState(null, '', qs ? location.pathname + '?' + qs : location.pathname);
  }

  function writeStateDebounced() {
    clearTimeout(writeStateTimer);
    writeStateTimer = setTimeout(function () {
      writeState(getCurrentState());
    }, 200);
  }

  function getCurrentState() {
    const checkedByType = {};
    document.querySelectorAll(SELECTORS.filterCheckbox + ':checked').forEach((cb) => {
      const type = cb.getAttribute('data-filter-type');
      if (!checkedByType[type]) checkedByType[type] = [];
      const slug = cb.value.toLowerCase().replace(/\s+/g, '-');
      if (!checkedByType[type].includes(slug)) checkedByType[type].push(slug);
    });
    const pMin = document.querySelector(SELECTORS.priceMin);
    const pMax = document.querySelector(SELECTORS.priceMax);
    const select = document.querySelector(SELECTORS.sortSelect);
    return {
      eventType: checkedByType['event-type'] || [],
      region: checkedByType['region'] || [],
      minPrice: pMin ? parseInt(pMin.value, 10) : null,
      maxPrice: pMax ? parseInt(pMax.value, 10) : null,
      sort: select ? select.value : null,
    };
  }

  function applyStateToDOM(state) {
    const pMin = document.querySelector(SELECTORS.priceMin);
    const pMax = document.querySelector(SELECTORS.priceMax);
    const absMin = pMin ? parseInt(pMin.min, 10) : 0;
    const absMax = pMax ? parseInt(pMax.max, 10) : 0;

    document.querySelectorAll(SELECTORS.filterCheckbox).forEach((cb) => {
      const type = cb.getAttribute('data-filter-type');
      const slug = cb.value.toLowerCase().replace(/\s+/g, '-');
      if (type === 'event-type') cb.checked = state.eventType.includes(slug);
      else if (type === 'region') cb.checked = state.region.includes(slug);
    });

    if (pMin && pMax) {
      const newMin = state.minPrice != null ? Math.max(absMin, Math.min(state.minPrice, absMax)) : absMin;
      const newMax = state.maxPrice != null ? Math.max(absMin, Math.min(state.maxPrice, absMax)) : absMax;
      pMin.value = String(newMin);
      pMax.value = String(newMax);
      pMin.dispatchEvent(new Event('input', { bubbles: true }));
      pMax.dispatchEvent(new Event('input', { bubbles: true }));
    }

    const sortValue = state.sort || 'relevance';
    const select = document.querySelector(SELECTORS.sortSelect);
    if (select) select.value = sortValue;
    syncSortRadios(sortValue);
  }

  /* ── Init ── */

  function init() {
    initSortOriginalOrder();
    bindFilterGroups();
    bindCheckboxFilters();
    bindPriceSlider();
    bindSort();
    bindMobileDrawers();
    bindShowMore();

    const initialState = readState();

    isHydrating = true;
    applyStateToDOM(initialState);
    isHydrating = false;

    sortCollections(initialState.sort || 'relevance');
    applyFilters();

    window.addEventListener('resize', applyMobileLimit);
  }

  function initSortOriginalOrder() {
    const grid = document.querySelector(SELECTORS.grid);
    if (!grid) return;
    grid.querySelectorAll(SELECTORS.card).forEach((card, index) => {
      if (!card.hasAttribute('data-original-index')) {
        card.setAttribute('data-original-index', String(index));
      }
    });
  }

  /* ── Collapsible filter groups ── */
  function bindFilterGroups() {
    document.querySelectorAll(SELECTORS.filterGroup).forEach((header) => {
      header.addEventListener('click', function () {
        this.closest('.collections-filter-group').classList.toggle('collections-filter-group--collapsed');
      });
    });
  }

  /* ── Checkbox filters ── */
  function bindCheckboxFilters() {
    document.querySelectorAll(SELECTORS.filterCheckbox).forEach((cb) => {
      cb.addEventListener('change', function () {
        const filterType = this.getAttribute('data-filter-type');
        const checkboxValue = this.value;
        document.querySelectorAll(SELECTORS.filterCheckbox).forEach((other) => {
          if (other !== this && other.getAttribute('data-filter-type') === filterType && other.value === checkboxValue) {
            other.checked = this.checked;
          }
        });
        if (!isHydrating) {
          applyFilters();
          writeState(getCurrentState());
        }
      });
    });
  }

  /* ── Price range slider ── */
  function bindPriceSlider() {
    let sliderSyncing = false;

    const primary = {
      min: document.querySelector(SELECTORS.priceMin),
      max: document.querySelector(SELECTORS.priceMax),
      isPrimary: true,
    };
    const drawer = {
      min: document.querySelector('.collections-drawer-price-min'),
      max: document.querySelector('.collections-drawer-price-max'),
      isPrimary: false,
    };

    function clampPair(pair, activeEl) {
      let minVal = parseInt(pair.min.value, 10);
      let maxVal = parseInt(pair.max.value, 10);
      const lo = parseInt(pair.min.min, 10);
      const hi = parseInt(pair.min.max, 10);
      if (Number.isNaN(minVal)) minVal = lo;
      if (Number.isNaN(maxVal)) maxVal = hi;
      if (minVal > maxVal) {
        if (activeEl === pair.min) pair.min.value = String(maxVal);
        else pair.max.value = String(minVal);
      }
    }

    function updatePairUI(pair) {
      let min = parseInt(pair.min.value, 10);
      let max = parseInt(pair.max.value, 10);
      const absMin = parseInt(pair.min.min, 10);
      const absMax = parseInt(pair.min.max, 10);
      const span = absMax - absMin;
      if (min > max) { const temp = min; min = max; max = temp; }

      const sliderRoot = pair.min.closest('.collections-price-slider');
      if (sliderRoot && span > 0) {
        sliderRoot.style.setProperty('--pct-left', ((min - absMin) / span * 100) + '%');
        sliderRoot.style.setProperty('--pct-right', ((max - absMin) / span * 100) + '%');
      }

      const container = pair.min.closest('.collections-filter-group__options');
      if (container) {
        const labels = container.querySelectorAll('.collections-price-values span');
        if (labels.length >= 2) {
          labels[0].textContent = formatCurrency(min);
          labels[1].textContent = formatCurrency(max);
        }
      }

      if (pair.isPrimary) {
        const minLabel = document.querySelector(SELECTORS.priceMinLabel);
        const maxLabel = document.querySelector(SELECTORS.priceMaxLabel);
        if (minLabel) minLabel.textContent = formatCurrency(min);
        if (maxLabel) maxLabel.textContent = formatCurrency(max);
      }
    }

    function syncPair(fromPair, toPair) {
      if (!toPair.min || !toPair.max) return;
      sliderSyncing = true;
      toPair.min.value = fromPair.min.value;
      toPair.max.value = fromPair.max.value;
      updatePairUI(toPair);
      sliderSyncing = false;
    }

    function bindDragStack(pair, el) {
      el.addEventListener('pointerdown', function () {
        if (el === pair.min) { pair.min.style.zIndex = '5'; pair.max.style.zIndex = '3'; }
        else { pair.max.style.zIndex = '5'; pair.min.style.zIndex = '3'; }
        const onUp = function () {
          pair.min.style.removeProperty('z-index');
          pair.max.style.removeProperty('z-index');
          window.removeEventListener('pointerup', onUp);
          window.removeEventListener('pointercancel', onUp);
        };
        window.addEventListener('pointerup', onUp);
        window.addEventListener('pointercancel', onUp);
      });
    }

    function setupPair(pair, otherPair) {
      if (!pair.min || !pair.max) return;

      bindDragStack(pair, pair.min);
      bindDragStack(pair, pair.max);

      function onInput(e) {
        if (sliderSyncing) return;
        clampPair(pair, e.target);
        updatePairUI(pair);
        syncPair(pair, otherPair);
        if (!isHydrating) {
          applyFilters();
          writeStateDebounced();
        }
      }

      pair.min.addEventListener('input', onInput);
      pair.max.addEventListener('input', onInput);
      updatePairUI(pair);
    }

    setupPair(primary, drawer);
    setupPair(drawer, primary);
  }

  function formatCurrency(value) {
    const lang = document.documentElement.lang || 'pt-BR';
    if (lang.startsWith('pt')) {
      return 'R$ ' + Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
    }
    return '$' + Number(value).toLocaleString('en-US', { minimumFractionDigits: 2 });
  }

  /* ── Apply all active filters ── */
  function applyFilters() {
    const cards = document.querySelectorAll(SELECTORS.card);
    if (!cards.length) return;

    const activeFilters = {};
    document.querySelectorAll(SELECTORS.filterCheckbox + ':checked').forEach((cb) => {
      const filterType = cb.getAttribute('data-filter-type');
      const filterValue = cb.value;
      if (!activeFilters[filterType]) activeFilters[filterType] = [];
      activeFilters[filterType].push(filterValue.toLowerCase());
    });

    let priceMin = 0;
    let priceMax = Infinity;
    let applyPriceFilter = false;
    const primaryMin = document.querySelector(SELECTORS.priceMin);
    const primaryMax = document.querySelector(SELECTORS.priceMax);

    if (primaryMin && primaryMax) {
      const rawMin = parseInt(primaryMin.value, 10);
      const rawMax = parseInt(primaryMax.value, 10);
      priceMin = Math.min(rawMin, rawMax);
      priceMax = Math.max(rawMin, rawMax);
      const absLo = parseInt(primaryMin.min, 10);
      const absHi = parseInt(primaryMax.max, 10);
      if (!Number.isNaN(absLo) && !Number.isNaN(absHi)) {
        applyPriceFilter = priceMin > absLo || priceMax < absHi;
      }
    }

    const filterTypes = Object.keys(activeFilters);
    let visibleCount = 0;

    cards.forEach((card) => {
      let show = true;

      for (const type of filterTypes) {
        const cardValue = (card.getAttribute('data-' + type) || '').toLowerCase();
        if (!activeFilters[type].some((activeValue) => cardValue.includes(activeValue))) {
          show = false;
          break;
        }
      }

      if (show && applyPriceFilter && Number.isFinite(priceMin) && Number.isFinite(priceMax)) {
        const cardPrice = parseFloat(card.getAttribute('data-min-price') || '0');
        if (cardPrice > 0 && (cardPrice < priceMin || cardPrice > priceMax)) show = false;
      }

      card.setAttribute('data-filtered', show ? 'false' : 'true');
      if (show) visibleCount++;
    });

    const noResults = document.querySelector(SELECTORS.noResults);
    if (noResults) noResults.style.display = visibleCount === 0 ? 'block' : 'none';

    applyMobileLimit();
  }

  function applyMobileLimit() {
    const showMore = document.querySelector(SELECTORS.showMore);
    if (!showMore) return;

    const isMobile = window.innerWidth <= MOBILE_BREAKPOINT;
    const limit = isMobile ? MOBILE_CARD_LIMIT : DESKTOP_CARD_LIMIT;

    const visibleCards = Array.from(
      document.querySelectorAll(SELECTORS.card + ':not([data-filtered="true"])')
    );

    document.querySelectorAll(SELECTORS.card + '[data-mobile-hidden]').forEach((c) => {
      c.removeAttribute('data-mobile-hidden');
    });

    if (visibleCards.length > limit) {
      visibleCards.slice(limit).forEach((c) => {
        c.setAttribute('data-mobile-hidden', 'true');
      });
      showMore.style.display = 'block';
    } else {
      showMore.style.display = 'none';
    }
  }

  function bindShowMore() {
    const btn = document.querySelector(SELECTORS.showMore + '__btn');
    if (!btn) return;
    btn.addEventListener('click', function () {
      document.querySelectorAll(SELECTORS.card + '[data-mobile-hidden]').forEach((c) => {
        c.removeAttribute('data-mobile-hidden');
      });
      const showMore = document.querySelector(SELECTORS.showMore);
      if (showMore) showMore.style.display = 'none';
    });
  }

  /* ── Sorting ── */
  function bindSort() {
    const select = document.querySelector(SELECTORS.sortSelect);
    if (select) {
      select.addEventListener('change', function () {
        sortCollections(this.value);
        syncSortRadios(this.value);
        if (!isHydrating) writeState(getCurrentState());
      });
    }

    const sortOpts = document.querySelector('.collections-sort-drawer__options');
    if (sortOpts) {
      sortOpts.addEventListener('change', function (e) {
        const radio = e.target;
        if (!radio.matches || !radio.matches('input[name="mobile-sort"]')) return;
        sortCollections(radio.value);
        if (select) select.value = radio.value;
        if (!isHydrating) writeState(getCurrentState());
        closeDrawer(SELECTORS.sortDrawer);
      });
    }

    if (select) syncSortRadios(select.value);
  }

  function syncSortRadios(value) {
    document.querySelectorAll(SELECTORS.sortRadio).forEach((radio) => {
      radio.checked = radio.value === value;
    });
  }

  function sortCollections(sortBy) {
    const grid = document.querySelector(SELECTORS.grid);
    if (!grid) return;

    const cards = Array.from(grid.querySelectorAll(SELECTORS.card));
    const noResults = grid.querySelector(SELECTORS.noResults);
    const showMore = grid.querySelector(SELECTORS.showMore);

    cards.sort((cardA, cardB) => {
      const nameA = (cardA.getAttribute('data-name') || '').toLowerCase();
      const nameB = (cardB.getAttribute('data-name') || '').toLowerCase();
      const dateA = cardA.getAttribute('data-date') || '';
      const dateB = cardB.getAttribute('data-date') || '';
      const priceA = parseFloat(cardA.getAttribute('data-min-price') || '0');
      const priceB = parseFloat(cardB.getAttribute('data-min-price') || '0');
      const origA = parseInt(cardA.getAttribute('data-original-index') || '0', 10);
      const origB = parseInt(cardB.getAttribute('data-original-index') || '0', 10);

      switch (sortBy) {
        case 'relevance':
        case 'discount':
          return origA - origB;
        case 'price_low':
          return (priceA > 0 ? priceA : Infinity) - (priceB > 0 ? priceB : Infinity);
        case 'alphabetical':
          return nameA.localeCompare(nameB);
        case 'alphabetical_reversed':
          return nameB.localeCompare(nameA);
        case 'date_reversed':
          return dateB.localeCompare(dateA);
        case 'date':
          return dateA.localeCompare(dateB);
        default:
          return origA - origB;
      }
    });

    cards.forEach((card) => grid.appendChild(card));
    if (noResults) grid.appendChild(noResults);
    if (showMore) grid.appendChild(showMore);

    applyMobileLimit();
  }

  /* ── Mobile drawers ── */
  function bindMobileDrawers() {
    bindDrawer(SELECTORS.filterDrawerOpen, SELECTORS.filterDrawer, SELECTORS.filterDrawerClose, SELECTORS.filterDrawerOverlay);
    bindDrawer(SELECTORS.sortDrawerOpen, SELECTORS.sortDrawer, SELECTORS.sortDrawerClose, SELECTORS.sortDrawerOverlay);

    const applyBtn = document.querySelector(SELECTORS.filterDrawerApply);
    if (applyBtn) {
      applyBtn.addEventListener('click', function () {
        closeDrawer(SELECTORS.filterDrawer);
      });
    }

    const clearBtn = document.querySelector(SELECTORS.filterDrawerClear);
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        clearAllFilters();
      });
    }
  }

  function clearAllFilters() {
    document.querySelectorAll(SELECTORS.filterCheckbox).forEach((cb) => {
      cb.checked = false;
    });

    const pMin = document.querySelector(SELECTORS.priceMin);
    const pMax = document.querySelector(SELECTORS.priceMax);
    if (pMin && pMax) {
      pMin.value = pMin.min;
      pMax.value = pMax.max;
      pMin.dispatchEvent(new Event('input', { bubbles: true }));
      pMax.dispatchEvent(new Event('input', { bubbles: true }));
    }

    applyFilters();
    clearTimeout(writeStateTimer);
    writeState({});
  }

  function bindDrawer(openSel, drawerSel, closeSel, overlaySel) {
    const openBtn = document.querySelector(openSel);
    const drawer = document.querySelector(drawerSel);
    const closeBtn = document.querySelector(closeSel);
    const overlay = document.querySelector(overlaySel);

    if (!drawer) return;

    if (openBtn) {
      openBtn.addEventListener('click', function () {
        drawer.classList.add(drawerSel.replace('.', '') + '--open');
        document.body.style.overflow = 'hidden';
      });
    }

    function close() {
      drawer.classList.remove(drawerSel.replace('.', '') + '--open');
      document.body.style.overflow = '';
    }

    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
  }

  function closeDrawer(drawerSel) {
    const drawer = document.querySelector(drawerSel);
    if (drawer) {
      drawer.classList.remove(drawerSel.replace('.', '') + '--open');
      document.body.style.overflow = '';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
